<template lang="html">
  <!-- <v-card dark>
    <v-card-title>
      <span class="headline"><strong>Patents</strong></span>
    </v-card-title>

    <v-card-text style="text-align: left;">
      <p>KING SHOW GAMES PATENT NOTICE PURSUANT TO 35 U.S.C. §287</p>

      <p>KSG gaming products may be covered by or licensed under one or more of the U.S. Patents listed below. Direct inquires to  <a href="mailto:ip@ksg.com" target="_top">ip@ksg.com</a>.</p>

      <ul>
        <li>US6709331</li>
        <li>US6896615</li>
        <li>US7364159</li>
        <li>US7513505</li>
        <li>US7674176</li>
        <li>US7704142</li>
        <li>US7874910</li>
        <li>US8016656</li>
        <li>US8152627</li>
        <li>US8197322</li>
        <li>US8202150</li>
        <li>US8282461</li>
        <li>US8298065</li>
        <li>US8323085</li>
        <li>US8342933</li>
        <li>US8517813</li>
        <li>US8585483</li>
        <li>US8636576</li>
        <li>US8641503</li>
        <li>US8684809</li>
        <li>US8752840</li>
        <li>US8758110</li>
        <li>US8771049</li>
        <li>US8771056</li>
        <li>US8814646</li>
        <li>US8876586</li>
        <li>US9011230</li>
        <li>US9070259</li>
        <li>US9114316</li>
        <li>US9153091</li>
        <li>US9171427</li>
        <li>US9171428</li>
        <li>US9171424</li>
        <li>US9251660</li>
        <li>US9349255</li>
        <li>US9412238</li>
        <li>US9418505</li>
        <li>US9443395</li>
        <li>US9466181</li>
        <li>US9472057</li>
        <li>US9530285</li>
        <li>US9536398</li>
        <li>US9536380</li>
        <li>US9552698</li>
        <li>US9564002</li>
        <li>US9569917</li>
        <li>US9569916</li>
        <li>US9569935</li>
        <li>US9569934</li>
        <li>US9576437</li>
        <li>US9576431</li>
        <li>US9589416</li>
        <li>US9633514</li>
        <li>US9633527</li>
        <li>US9633522</li>
        <li>US9640037</li>
        <li>US9711011</li>
        <li>US9715792</li>
        <li>D793409</li>
        <li>US9721432</li>
        <li>US9747757</li>
        <li>US9773369</li>
        <li>US9786117</li>
        <li>US9786131</li>
        <li>US9818257</li>
        <li>US9911269</li>
        <li>US9916730</li>
        <li>US9916733</li>
      </ul>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="orange darken-1" flat="flat" @click="okClicked">OK</v-btn>
    </v-card-actions>
  </v-card> -->
  <v-container justify-center wrap fluid class="patents-container">
    <v-layout justify-center wrap>
      <v-flex xs12 sm8 md6>
        <h1 class="patents-title">Patents</h1>

        <v-flex mt-4 text-xs-left>
          <p class="body-text">KING SHOW GAMES PATENT NOTICE PURSUANT TO 35 U.S.C. &sect;287</p>
          <p class="body-text">KSG gaming products may be covered by or licensed under one or more of the U.S. Patents listed below. &nbsp;Direct inquires to <a href="mailto:ip@ksg.com" target="_top" class="email-style">ip@ksg.com</a></p>
        </v-flex>

        <v-flex mt-4>
          <hr>
        </v-flex>

        <v-flex mt-4 text-xs-left>
          <p class="body-text">US6709331,
            US6896615,
            US7364159,
            US7513505,
            US7674176,
            US7704142,
            US7874910,
            US8016656,
            US8152627,
            US8197322,
            US8202150,
            US8282461,
            US8298065,
            US8323085,
            US8342933,
            US8517813,
            US8585483,
            US8636576,
            US8641503,
            US8684809,
            US8752840,
            US8758110,
            US8771049,
            US8771056,
            US8814646,
            US8876586,
            US9011230,
            US9070259,
            US9114316,
            US9153091,
            US9171427,
            US9171428,
            US9171424,
            US9251660,
            US9349255,
            US9412238,
            US9418505,
            US9443395,
            US9466181,
            US9472057,
            US9530285,
            US9536398,
            US9536380,
            US9552698,
            US9564002,
            US9569917,
            US9569916,
            US9569935,
            US9569934,
            US9576437,
            US9576431,
            US9589416,
            US9633514,
            US9633527,
            US9633522,
            US9640037,
            US9711011,
            US9715792,
            US9721432,
            US9747757,
            US9773369,
            US9786117,
            US9786131,
            US9818257,
            US9911269,
            US9916730,
            US9916733,
            US9953488,
            US10008075,
            US10074241,
            US10089831,
            US10121317,
            US10127772,
            US10134241,
            US10163296,
            US10169959,
            US10192391,
            US10217316,
            US10311669,
            US10332357,
            US10347087,
            US10347090,
            US10360765,
            US10373437,
            US10373429,
            US10395467,
            US10410476,
            US10424161,
            US10445976,
            US10453304,
            US10467859,
            US10467860,
            US10467866,
            US10504330,
            US10529182,
            US10535220,
            US10553081,
            US10553080,
            US10580257,
            US10600278,
            US10600288,
            US10607443,
            US10657759,
            US10692328,
            US10699517,
            US10713896,
            US10713902,
            US10741008,
            US10769891,
            US10783747,
            US10783741,
            US10783754,
            US10803698,
            US10810830,
            US10896577,
            US10916097,
            US10916098,
            US10957163,
            US10964156,
            US10970970,
            US10997824,
            US11011028,
            US11037402,
            US11069193,
            US11087594,
            US11183020,
            US11183021,
            US11189132,
            US11195381,
            US11200783,
            US11222500,
            US11222509,
            US11232682,
            US11232678,
            US11244540,
            US11263861,
            US11328560,
            US11410505,
            US11423741,
            US11482079,
            US11501603,
            US11508218,
            US11545008,
            US11551525,
            US11551528,
            US11562619,
            US11587402,
            US11710376,
            US11734991,
            US11776359,
            US11776363,
            US11776364,
            US11790734,
            US11798348,
            US11830325,
            US11869299,
            US11887434,
            US11908280,
            US11922770,
            US11954980,
            US11954981,
            US12014601,
            US12051305,
            US12067848,
            US12154414,
            US12165466,
            US12183159,
            US12183166,
            US12190685,
            US12198507,
            D793409
            </p>
          <p class="body-text">Other Patent Applications Pending</p>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { EventBus } from '../utils/eventBus'
export default {
  name: 'Patents',
  methods: {
    okClicked () {
      EventBus.$emit('patentsClicked')
    }
  }
}
</script>

<style lang="scss" scoped>
.patents-container {
  background-color: rgba(0,0,0,0.1);
}

.patents-title {
  font-family: museo-slab, serif;
  font-style: italic;
  font-weight: 700;
  font-size: 45px;
  color: #f6821f;
  letter-spacing: -1px;
}

.body-text {
  font-size: 18px;
}

.email-style {
  font-family: museo-slab, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  color: #5677c3;
  text-decoration: none;
}
</style>
